export class LeftSlidebarController {
  constructor($scope, $rootScope) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
  }
}
